export class FindAllForms {
  public static readonly type = '[Project/Form/List] FindAllForms';
}
